import React, { FC } from 'react';
import PropTypes from 'prop-types';
import logoInNonBackground from '../assets/logos/logoInNonBackground.jpg';

interface ILogoProps {
	width?: number;
	height?: number;
}
const Logo: FC<ILogoProps> = ({ width, height }) => {
	return (
		<img src={logoInNonBackground}
			// width={160} height={160}
			width={width}
			height={height}
		/>
	);
};
Logo.propTypes = {
	width: PropTypes.number,
	height: PropTypes.number,
};
Logo.defaultProps = {
	width: 2155,
	height: 854,
};

export default Logo;
